/**
 * Tipos de suscripción disponibles
 * Estos valores deben coincidir con los nombres que vienen del backend
 */
export const SUBSCRIPTION_TYPES = {
	PRO: "Pro",
	FRIENDS: "Friends", // Tiene los mismos permisos que PRO
	TRIAL: "Trial",
	FREE: "Free",
	BASIC_PLAIN: "Basic",
	BASIC_HADDOCK: "Basic haddock",
};

/**
 * Planes que tienen acceso completo a funcionalidades premium
 * FRIENDS se considera equivalente a PRO
 */
export const PREMIUM_PLANS = [
	SUBSCRIPTION_TYPES.PRO,
	SUBSCRIPTION_TYPES.FRIENDS,
];

/**
 * Funcionalidades controladas por tipo de suscripción
 * Cada funcionalidad define qué tipos de suscripción tienen acceso
 */
export const SUBSCRIPTION_FEATURES = {
	// Módulo: Planificación
	PLANNING: {
		name: "Planificación",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS,
			SUBSCRIPTION_TYPES.TRIAL,
			SUBSCRIPTION_TYPES.FREE,
			SUBSCRIPTION_TYPES.BASIC_PLAIN,
		],
		upgradeMessage:
			'Mostramos modal upgrade al clicar en "Planificación" en el sidebar',
	},
	PLANNING_AI: {
		name: "Planificación con IA",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
		],
		upgradeMessage: 'Mostramos modal upgrade al clicar en "Planificar con IA"',
	},
	FORECASTING: {
		name: "Forecast",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
		],
		upgradeMessage: 'Mostramos modal upgrade al clicar en "Forecasting"',
	},
	MY_CALENDAR: {
		name: "Mi calendario",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS,
			SUBSCRIPTION_TYPES.TRIAL,
			SUBSCRIPTION_TYPES.FREE,
			SUBSCRIPTION_TYPES.BASIC_PLAIN,
		],
	},

	// Módulo: Fichajes
	CLOCKING_TERMINAL: {
		name: "Terminal de fichajes",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
			SUBSCRIPTION_TYPES.TRIAL,
			SUBSCRIPTION_TYPES.BASIC_HADDOCK,
		],
		upgradeMessage: "No se podrá invocar el terminal desde el sidebar",
	},

	// Módulo: Reglas
	CREATE_RULES: {
		name: "Poder crear nuevas reglas",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS,
			SUBSCRIPTION_TYPES.TRIAL,
			SUBSCRIPTION_TYPES.FREE,
			SUBSCRIPTION_TYPES.BASIC_PLAIN,
		],
	},

	// Módulo: Ausencias
	TWO_LEVEL_APPROVAL: {
		name: "Flujo de aprobación de 2 niveles",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
			SUBSCRIPTION_TYPES.TRIAL,
		],
		upgradeMessage:
			'No se podrá habilitar el componente "Segundo nivel de aprobación de ausencias"',
	},

	// Módulo: Documentos
	SIGN_DOCUMENTS: {
		name: "Firmar documentos",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
			SUBSCRIPTION_TYPES.TRIAL,
			SUBSCRIPTION_TYPES.BASIC_HADDOCK,
		],
	},
	MASS_SENDING_DOCUMENTS: {
		name: "Envío masivo",
		allowedPlans: [
			SUBSCRIPTION_TYPES.PRO,
			SUBSCRIPTION_TYPES.FRIENDS, // FRIENDS tiene los mismos permisos que PRO
		],
		upgradeMessage: 'Mostramos modal upgrade al clicar en "Subir documentos"',
	},

	// Módulo: Gastos
	EXPENSES: {
		name: "Gastos",
		allowedPlans: [SUBSCRIPTION_TYPES.PRO, SUBSCRIPTION_TYPES.FRIENDS],
		upgradeMessage:
			'Mostramos modal upgrade al clicar en "Gastos" en el sidebar',
	},
};
